<template>
    <!--  
    -------  We use this component to support WCAG specifications, it is hidden at rendering ----
    -->
    <span class="a-hero-title">
        <h1>{{text}}</h1>
        <h2>{{text}}</h2>
    </span>
</template>

<script>
export default {
    name: 'AHeroTitle',
    props: {
        text: {
            type: String,
            default: 'Hospital map'
        }
    }
}
</script>

<style lang="scss">
@import "a-hero-title";
</style>